import { phoneState } from '../state';

const handleRegistrationOverwritten = async () => {
  phoneState.registrationOverwritten = true;
};

export default handleRegistrationOverwritten;
